import { sendGaSubscribedEvent } from './utils/ga-events';
import { api } from 'api';
import log from 'loglevel';
import { html, LitElement } from 'lit-element';
import { safeDefine } from 'lm-ui-kit/src/utils/define-element';
import { ternary } from '../utils';
import { getQaCookies } from 'utils';
import { styles } from './styles';

import '../uc-page-content';
import '../uc-form-input';
import '../uc-form-title';
import '../uc-form-subtitle';
import '../uc-form-success';
import '../uc-circular-loader';
import 'lm-ui-kit/src/components/uc-button/uc-button.define';

class UcFooterSubscribe extends LitElement {
  static get properties() {
    return {
      method: { type: String },
      action: { type: String },
      regionID: { type: String },
      _subscribed: { type: Boolean },
      _error: { type: String },
      _value: { type: String },

      subscribersApiKey: { type: String },
      subscribersUrl: { type: String },
      recaptchaPublicKey: { type: String },
    };
  }

  static styles = styles;

  constructor() {
    super();
    this.method = 'POST';
    this.action = '';
    this.regionID = '0';

    this._subscribed = false;
    this._error = '';
    this._value = '';

    this._maxEmailLength = 60;

    this.session_token = '';
    this.subscribersApiKey = '';
    this.subscribersUrl = '';
    this.recaptchaPublicKey = '';
  }

  _onInput(e) {
    this._value = e.target.value;
    this._error = '';
  }

  _onFocus = async () => {
    try {
      const { load } = await import('recaptcha-v3');
      const recaptcha = await load(this.recaptchaPublicKey, { autoHideBadge: true });
      const token = await recaptcha.execute('homepage');
      this.session_token = token;
    } catch (error) {
      log.error(error, 'Модуль recaptcha-v3 не загружен');
    }
  };

  _onSubmit = async e => {
    e.preventDefault();
    this._error = '';

    if (!this.session_token) {
      log.error('Не удалось получить session_token');
      return;
    }

    let url = this.subscribersUrl;

    const options = {
      headers: {
        'x-api-key': this.subscribersApiKey,
      },
    };

    const qaCookie = getQaCookies(document?.cookie);

    if (qaCookie) {
      const params = new URLSearchParams({ testId: qaCookie.split('=')[1] }).toString();
      url += `?${params}`;
    }

    try {
      const response = await api.post(
        url,
        {
          contact: this._value,
          gtoken: this.session_token,
        },
        options
      );
      if (response?.message === "Client already subscribed") {
        throw this._error = 'подписка уже оформлена';
      }
      this._value = '';
      this._subscribed = true;
      sendGaSubscribedEvent();
    } catch (error) {
      this._error = typeof error === 'string' ? error : 'Ошибка при выполнении запроса';
    }
  };

  render() {
    return html`
      <div>
        <form @submit=${this._onSubmit} action=${this.action} method=${this.method}>
          <input
            id="footer-subscrube-input"
            type="email"
            name="email"
            class="footer-subscrube-input"
            required
            maxlength="${this._maxEmailLength}"
            spellcheck="false"
            autocorrect="off"
            placeholder="Введите Ваш e-mail"
            .value="${this._value}"
            @input=${this._onInput}
            @focus=${this._onFocus}
          />
          <label for="footer-subscrube-input">Введите Ваш e-mail</label>
          <input type="hidden" id="google-recaptcha-response" name="google-recaptcha-response" />
          <input type="hidden" name="personal_city" value="${this.regionID}" />
          <uc-button class="submit-button">
            <button class="submit-button-inner">ПОДПИСАТЬСЯ НА&nbsp;РАССЫЛКУ</button>
          </uc-button>
          ${ternary(this._error, html` <p class="error-text">${this._error}</p> `)}
        </form>
        <uc-overlay ?show=${this._subscribed} @close=${() => (this._subscribed = false)}>
          <uc-page-content class="subscrube-popup-content">
            <p class="title">Благодарим Вас за подписку на рассылку!</p>
            <p class="description">Для подтверждения подписки, Вам нужно перейти по ссылке в письме.</p>
          </uc-page-content>
        </uc-overlay>
      </div>
    `;
  }
}

safeDefine('uc-footer-subscribe', UcFooterSubscribe);
